<template>
  <div>
    <QS-scroller-box>
      <QS-h3-title :title="pageTitle" />
      <el-alert
        v-if="(approvalState == 30 || state == 2) && discardDesc"
        class="reject-alert"
        :title="discardDesc"
        type="error"
      />
      <QS-h4-title title="收款信息" />
      <CollectionRecordDetailsForm
        :source="source"
        :enterScene="1"
        scenetype="receivable"
      />
      <QS-h4-title title="收款单" />
      <collection-record-details-table
        :tableData="receivableList"
        :freeTypeList="formatEnumeration(freeTypeList)"
      />
      <div slot="bottomAction" class="button-container">
        <el-button @click="cancel"> 取消 </el-button>
        <el-button
          @click="showWithdrawApprovalDialog"
          v-if="type === 'order' && state === 0"
          type="primary"
        >
          撤回审批
        </el-button>
        <el-button
          @click="lookApprovalDetail"
          type="primary"
          v-if="this.accessMode === 2"
        >
          查看审批动态
        </el-button>
        <!-- biztype ： 1，bizId： id -->
        <!-- approvalState：10 待审批 -->
        <div
          v-if="type === 'approval' && approvalState == 10 && showBackground"
        >
          <el-button
            class="approval-reject"
            @click="approvalOperation(30)"
            type="primary"
            v-if="
              this.judgePermission('company_new_approval_manage_list_rebut')
            "
          >
            审批驳回
          </el-button>
          <el-button
            @click="approvalOperation(40)"
            type="primary"
            v-if="
              this.judgePermission('company_new_approval_manage_list_approved')
            "
          >
            审批通过
          </el-button>
        </div>
      </div>
    </QS-scroller-box>
    <approval-dialog
      :dialogVisible="approvalDialogVisible"
      :title="approvalDialogTitle"
      :approvalData="approvalData"
      :content="approvalDialogContent"
      :callbackFn="type === 'order' ? withdrawApproval : null"
      @close="resetDialogData"
      @refreash="refreash"
    />
    <!--  bizType 1 个人租赁应收审批 / 2租赁退车付款审批 / 3租赁退车收款审批 / 4支付宝支付解约 / 5网约钱包支付解约  -->
    <lookApprovalDetail
      ref="lookApprovalDetail"
      :bizId="this.id"
      :bizType="1"
    />
  </div>
</template>

<script>
import {
  getbatchCollectionRecordDetails,
  getBatchReceivableOrderList,
  withdrawApproval,
} from '@/api/domain/finance'
import CollectionRecordDetailsForm from '@/components/CollectionRecordDetails/CollectionRecordDetailsForm.vue'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'
import ApprovalDialog from './approvalDialog.vue'
import CollectionRecordDetailsTable from './collectionRecordDetails/CollectionRecordDetailsTable'
import lookApprovalDetail from './lookApprovalDetail'

const titleMap = {
  order: '订单收款详情',
  overdue: '逾期收款详情',
}

export default {
  name: 'cpInfoDetail',
  components: {
    CollectionRecordDetailsTable,
    CollectionRecordDetailsForm,
    ApprovalDialog,
    lookApprovalDetail,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      id: '',
      receivableList: [],
      source: {
        businessLicensePhoto: [],
        companyPhoto: [],
      },
      state: '', // 收款记录状态
      type: '', // 'order：订单；approval：审批管理'
      reviewId: '', // 审批id,审批通过和驳回使用
      rentOrderId: '', // 订单id
      approvalState: '', // 审批状态
      discardDesc: '', // 展示作废原因
      pageTitle: '',
      approvalDialogVisible: false, // 审批弹框
      approvalDialogTitle: '',
      approvalDialogIsReject: false, // 审批弹框拒绝原因
      approvalDialogContent: '',
      approvalData: {},
      accessMode: '', // 审批类型 1-后台审批 2-钉钉审批
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    // 后台审批是否展示
    showBackground() {
      if (
        (this.judgePermission('company_new_approval_manage_list_rebut') ||
          this.judgePermission('company_new_approval_manage_list_approved')) &&
        Number(this.accessMode) === 1
      ) { return true } else return false
    },
  },
  methods: {
    // 查看审批动态
    lookApprovalDetail() {
      this.$refs.lookApprovalDetail.dialogVisible = true
    },
    // 取消操作
    cancel(isSuccess = false) {
      const { type } = this
      if (type === 'order' && !isSuccess) {
        this.backOrderRouter()
      } else {
        !isSuccess && this.$router.back()
        isSuccess && this.$refreshBack(true) // 刷新列表页
      }
    },

    backOrderRouter() {
      const { rentOrderId } = this
      const query = {
        id: rentOrderId,
        type: 1,
      }
      this.$router.push({
        path: '/purchase/leasecontract/details',
        query,
      })
    },

    resetDialogData() {
      this.approvalDialogVisible = false
      this.approvalDialogTitle = ''
      this.approvalDialogIsReject = false
      this.approvalDialogContent = ''
      this.approvalData = {}
    },

    // 弹框确认后后逻辑
    refreash() {
      this.resetDialogData()
      this.cancel(true)
    },

    // 审批功能
    approvalOperation(state) {
      const { reviewId } = this
      this.approvalDialogTitle = { 30: '确认驳回原因', 40: '确认通过' }[state]
      this.approvalData = {
        id: reviewId,
        state,
      }
      if (state === 40) {
        this.approvalDialogContent = '确定审批通过吗?'
      }
      this.approvalDialogVisible = true
    },

    // 撤回弹框
    showWithdrawApprovalDialog() {
      this.approvalDialogTitle = '是否撤回'
      this.approvalDialogContent =
        '确认撤回吗？撤回后将收款变为作废状态，需要重新发起收款。'
      this.approvalDialogVisible = true
    },

    // 撤回审批
    async withdrawApproval() {
      const { id } = this
      const params = {
        bizId: id,
        bizType: 1,
      }
      withdrawApproval(params).then(({ code }) => {
        if (code === 1) {
          this.$message({
            type: 'success',
            message: '撤回成功',
            onClose: () => {
              this.backOrderRouter()
            },
          })
        }
      })
    },

    // 获取详情
    async getDetail(id) {
      const { code, data } = await getbatchCollectionRecordDetails({ id })
      if (code === 1) {
        this.state = data.state
        this.discardDesc = data.discardDesc || ''
        this.source = {
          ...data,
          attachment: data.attachment,
          state: selectOption.collectionStateList[data.state] || '--',
          amount: `${this.numberWithCommas(data.amount)} 元 `,
        }
      }
    },

    // 获取应收列表数据
    getBatchReceivableOrderList(id) {
      getBatchReceivableOrderList({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.receivableList =
            data &&
            data.map((item, index) => {
              item.index = index + 1
              item.state = selectOption.collectionStateList[item.state] || '--'
              return item
            })
        }
      })
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    const {
      id,
      type,
      rentOrderId = '',
      approvalState,
      reviewId,
      accessMode,
    } = this.params
    this.type = type
    this.id = id
    this.rentOrderId = rentOrderId
    this.pageTitle = titleMap[type] || '收款详情'
    if (type === 'approval') {
      this.reviewId = reviewId
      this.approvalState = approvalState
    }
    if (id) {
      this.getDetail(id)
      this.getBatchReceivableOrderList(id)
    } else {
      this.$message.error('缺少参数')
      this.$router.back()
    }
    this.accessMode = accessMode
  },
}
</script>

<style lang="scss" scoped>
.reject-alert {
  padding: 8px 10px;
  margin-bottom: 16px;
  margin-top: -8px;
}
.btn-cancel {
  margin-right: 12px;
}
.approval-reject {
  margin-left: 14px;
}
.button-container {
  display: flex;
}
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .qs-h4-container-left {
  font-size: 16px;
}

.company_photos {
  ::v-deep .el-form-item__label {
    min-width: 162px;
  }

  .images-list {
    font-size: 0;
    width: 500px;
    height: 200px;
    flex-wrap: wrap;

    img {
      width: 80px;
      height: 80px;
      margin-left: 12px;

      &:nth-child(1),
      &:nth-of-type(6) {
        margin-left: 0;
      }

      &:nth-of-type(n + 6) {
        margin-top: 16px;
      }
    }
  }
}
</style>
